"use client";

import { useCallback } from "react";
import { FILTERS_ARRAY } from "@/constants/gallery-images";
import { useMainGalleryQueries } from "@/hooks/use-main-gallery-queries";
import { MainGalleryFilterOption } from "./main-gallery-filter-option";
import type { Filters } from "@/types/images-categories.types";

const FILTER_LABELS: Record<Filters, string> = {
  all: "Sve",
  cosmetic: "Kozmetičke",
  restorative: "Restorativne",
  orthodontic: "Ortodontske",
};

export function MainGalleryFilters() {
  const { mainGallery, setMainGallery } = useMainGalleryQueries();

  const handleFilterClick = useCallback(
    (filter: Filters) => {
      setMainGallery((prev) => ({
        filter,
        destination: prev.destination,
      }));
    },
    [setMainGallery],
  );

  const { filter: selectedFilter } = mainGallery;

  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 w-full items-center lg:w-fit gap-3 h-full">
      {FILTERS_ARRAY.map((filter) => (
        <MainGalleryFilterOption
          key={filter}
          label={FILTER_LABELS[filter]}
          onSelect={handleFilterClick}
          selected={selectedFilter === filter}
          value={filter}
        />
      ))}
    </div>
  );
}
